<template lang="html">
  <div class="succeed">
    <div class="activityDesc" v-html="activityInfoData.home_register_desc"></div>
  </div>
</template>

<script>
  import Cookies from 'js-cookie';
  import WxShare from '@/utils/wxshare';
  import { pagebase } from '@/utils/http.js';

  export default {
    data() {
      return {
        activityId: this.$route.query.aid,
        channelId: this.$route.query.channel || 0,
        activityInfoData: {},
        pagebase: pagebase,
      }
    },

    mounted() {
      this.init()
    },

    methods: {
      init() {
        this.getActivityInfo()
      },

      getActivityInfo() {
        this.$http({
          url: '/api/getH5ActivityInfo',
          method: 'get',
          params: {
            uid: Cookies.get('uid') || '',
            token: Cookies.get('token') || '',
            activity_id: this.activityId,
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.activityInfoData = res.data;
            document.title = '恭喜领取成功';

            new WxShare().share({
              title: this.activityInfoData.title,
              desc: '海量资料免费领~',
              link: pagebase + '/#/customActivityHome?aid=' + this.activityId + '&channel=' + this.channelId,
              imgUrl: this.activityInfoData.cover,
            });
          }
        })
      },
    }
  }
</script>

<style lang="css" scoped>
  .activityDesc>>>img {
    width: 100% !important;
  }
</style>